import styles from "../Paragraph.module.css";

/**
 * ParagraphHeading - opcjonalny <h2> z nazwa akapitu.
 *
 * Renderuje <h2 className={styles.paragraphName}> tylko gdy `name` jest podany.
 * Gdy `center_header === true` (admin zaznaczyl checkbox "Wysrodkuj naglowek")
 * dodaje modifier class `paragraphNameCentered` (text-align:center).
 *
 * Centralny punkt - kazdy ParagraphX layout reuse'uje ten komponent zamiast
 * inline'owania `<h2 className={styles.paragraphName}>`. Dzieki temu logika
 * centering jest w jednym miejscu, latwa do rozszerzenia (np. left/right
 * alignment, custom font-weight per layout).
 */
export function ParagraphHeading({
  name,
  centerHeader,
}: {
  name?: string | null;
  centerHeader?: boolean;
}) {
  if (!name) return null;
  const className = centerHeader
    ? `${styles.paragraphName} ${styles.paragraphNameCentered}`
    : styles.paragraphName;
  return <h2 className={className}>{name}</h2>;
}
